module.exports = __webpack_public_path__ + "img/des-3.70c40c18.jpg";